
    import Vue from 'vue';
    import AsModal from '@/components/Ui/AsModal.vue';
    import { settingsHelper } from '@/store/modules/settings';
    const settingsHelpers = settingsHelper.mapGetters(['providers']);

    export default Vue.extend({
	    name: 'WhatIsOpenBanking',
    	components: {
	    	AsModal,
	    },
	    computed: {
		    ...settingsHelpers,
		    yodlee(): boolean {
			    return this.providers.yodlee;
		    },
		    openBanking(): boolean {
			    return this.providers.openBanking;
		    },
	    },
    });
